import { gql } from "@apollo/client";

export const GET_PURCHASERS = gql`
  query Purchasers($page_number: Int!, $page_size: Int!) {
    purchasers(
      params: { page_number: $page_number, page_size: $page_size, sort_column: "purchaser_name", sort_order: "ascend" }
    ) {
      total
      page
      limit
      totalActiveCount
      items {
        purchaserId
        purchaserKey
        purchaserName
        purchaserIsActive
        associatedBrandsCount
        associatedBrands {
          brandId
          brandName
          brandKey
          brandPurchaserId
          purchaserInboxEmailId
          isActive
        }
        brandPurchaser {
          id
          email
          isActive
          createdAt
          createdBy
          updatedAt
          updatedBy
          deletedAt
          deletedBy
        }
        configTemplate {
          configTemplateId
          appPurchaserId
          metadata
          searchKeywords
          intelligenceFilter
          deductionTypeInvoicePatternForDiscount
          additionalFieldMapping
          discountTermAgreementDaysTolerance
          isActive
        }
      }
    }
  }
`;
